import Collection from 'ol/Collection';
import Feature from 'ol/Feature';
import { Circle } from 'ol/geom';
import { Modify, Translate } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat, toLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import { FENCE_CIRCLE_RADIUS_MIN } from '@/config';
import { STYLES } from '@/define/olMaps';
import OlMap from '@/helpers/OlMap';
import { NotifierService as notifier } from '@/libs/Notifier';
import CoordUtils from '@/utils/CoordUtils';
import { convertProjectedRadiusToMeters, convertMetersToProjectedRadius } from '@/utils/FenceUtil';

const FenceCircle = ({ index, data }) => {
  const dispatch = useDispatch();
  const map = OlMap.getMap();

  const originCenter = useMemo(() => {
    return fromLonLat([data.center.lng, data.center.lat]);
  }, [data.center]);

  const originRadius = useMemo(() => {
    return convertMetersToProjectedRadius(data.center, data.radius);
  }, [data]);

  useEffect(() => {
    const feature = new Feature(new Circle(originCenter, originRadius));
    const source = new VectorSource({ features: [feature], wrapX: false });
    const layer = new VectorLayer({
      source,
      style: STYLES.MISSION.FENCE,
    });
    map.addLayer(layer);

    const translate = new Translate({ features: new Collection([feature]) });
    translate.on('translateend', editCircle);
    map.addInteraction(translate);

    const modify = new Modify({ source });
    modify.on('modifyend', editCircle);
    map.addInteraction(modify);

    return () => {
      source.clear();
      map.removeLayer(layer);
      map.removeInteraction(modify);
      map.removeInteraction(translate);
    };
  }, [originCenter, originRadius]);

  const editCircle = (e) => {
    const circle = e.features.item(0).getGeometry();
    const radius = convertProjectedRadiusToMeters(circle);
    // 반지름 10m 미만 시
    if (radius < FENCE_CIRCLE_RADIUS_MIN) {
      handleInvalidAction(e, `The fence radius cannot be smaller than ${FENCE_CIRCLE_RADIUS_MIN}m. Please retry.`);
      return;
    }

    const center = CoordUtils.objectFromArray(toLonLat(circle.getCenter()));

    dispatch(actions.mission.mavlink.editFence(index, { center, radius }));
  };

  const handleInvalidAction = (e, message) => {
    e.features.item(0).getGeometry().setCenter(originCenter);
    e.features.item(0).getGeometry().setRadius(originRadius);
    notifier.error(message);
  };

  return null;
};

export default FenceCircle;
